var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDragHandler48Line = function SvgIconDragHandler48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.401 13.598a2.6 2.6 0 1 0 5.2 0 2.6 2.6 0 0 0-5.2 0ZM27.401 34.399a2.6 2.6 0 1 0 5.2 0 2.6 2.6 0 0 0-5.2 0ZM27.401 23.998a2.6 2.6 0 1 0 5.2 0 2.6 2.6 0 0 0-5.2 0ZM15.401 13.598a2.6 2.6 0 1 0 5.2 0 2.6 2.6 0 0 0-5.2 0ZM15.401 34.399a2.6 2.6 0 1 0 5.2 0 2.6 2.6 0 0 0-5.2 0ZM15.401 23.998a2.6 2.6 0 1 0 5.2 0 2.6 2.6 0 0 0-5.2 0Z",
    fill: "current"
  })));
};
export default SvgIconDragHandler48Line;